export function decodificarTipoTratamiento(codigo) {
  const decodificaciones = {
    D: 'Diagnóstico',
    T: 'Terapuetico',
    E: 'Educacional'
  };

  return decodificaciones[codigo] || '';
}

export function decodificarTipoDiag(codigo) {
  const decodificaciones = {
    P: 'Presuntivo',
    D: 'Definitivo'
  };

  return decodificaciones[codigo] || '';
}

export function decodificarTipoAnte(codigo) {
  const decodificaciones = {
    P: 'Antecedente Personal',
    F: 'Antecedente Familiar',
    Y: 'Antecedentes Patológicos Personales y Familiares'
  };

  return decodificaciones[codigo] || '';
}

export function decodificarTipoCita(codigo) {
  const decodificaciones = {
    I: 'Inicial',
    S: 'Subsecuente'
  };

  return decodificaciones[codigo] || '';
}

export function decodificarTipoPersona(codigo) {
  const tiposPersona = {
    N: 'Natural',
    J: 'Jurídica'
  };

  return tiposPersona[codigo] || 'Desconocido';
}

export function decodificarGenero(codigo) {
  const generos = {
    M: 'Masculino',
    F: 'Femenino'
  };

  return generos[codigo] || 'Desconocido';
}

export function decodificarNivelCombustible(codigo) {
  const nivelCombustible = {
    1: '20%',
    2: '40%',
    3: '60%',
    4: '80%',
    5: '100%'
  };

  return nivelCombustible[codigo] || 'Desconocido';
}

export function decodificarEstadoAsiento(codigo) {
  const estadoAsiento = {
    P: 'Pendiente',
    A: 'Anulada',
    E: 'Ejecutado'
  };

  return estadoAsiento[codigo] || 'Desconocido';
}

export function decodificarSiNo(codigo) {
  const siNo = {
    1: 'Si',
    0: 'No'
  };

  return siNo[codigo] || 'Desconocido';
}

export function decodificarEstadoRolPago(codigo) {
  const estadosRolPago = {
    P: 'Pendiente',
    R: 'Procesado',
    A: 'Anulado'
  };

  return estadosRolPago[codigo] || 'Desconocido';
}

export function decodificarTipoComponente(codigo) {
  const tipoComponente = {
    1: 'Ingreso',
    0: 'Egreso'
  };

  return tipoComponente[codigo] || 'Desconocido';
}

export function decodificarEstadoAviso(codigo) {
  const decodificaciones = {
    P: 'Pendiente',
    E: 'Enviado',
    C: 'Cancelado'
  };

  return decodificaciones[codigo] || '';
}